import React from 'react'
import styled from "styled-components"
import { colors, mediaQueries } from '../shared/config'

const Background = styled.div`
    background-color : ${colors.red};
    height: 100%;
    padding-bottom: 20px;
`

const Container = styled.div`
    width: 90%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    ${mediaQueries.mobile}{
        width: 90%;
        align-items: flex-start;

    }
`

const DescriptionContainer = styled(Container)`
    /* height: 650px; */
    padding-top: 100px;

    ${mediaQueries.mobile} {
        padding-top: 75px;
        text-align: left;
    }
`

const Heading = styled.p`
    font-size: 72px;
    font-family: Staatliches;
    font-style: normal;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 72px;
    line-height: 75%;
    color: white;
    margin: 0 0 0.5em 0;
    ${mediaQueries.mobile} {
        font-size: 36px;
        text-align: left;
        margin-left: 30px;
    }
`

const SubHeading = styled.p`
    font-family: Staatliches;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 75%;
    text-transform: uppercase;
    color: white;
    margin: 0 0 10px 0;
    ${mediaQueries.mobile} {
        font-size: 24px;
        width: 100%;
        padding-left: 30px;
    }
`

const Text = styled.p`
    color: white;
    text-align: left;
    font-family: Cardo;
    font-style: normal;
    font-weight: normal;
    padding: 30px;
    ${mediaQueries.mobile}{
    margin: 30px 0;
  }
`

const Video = styled.video`
  object-fit: fill;
    height: 80%;
    width: 80%;
  margin: 30px 30px;
  /* margin-bottom: 20px; */
  ${mediaQueries.tablet} {
    /* width: 100%; */
    width: calc(100% - 20px);
    height: auto;
    margin: auto 100px;
  }
  ${mediaQueries.mobile}{
    width: calc(100% - 35px);
    /* width: 100%; */
    margin: 10px 20px;
    height: auto;
    align-items: center;
  }
`


// const Credits = styled.div`

//   font-family:Prompt;
//   font-style: Cardo;
//   font-size: 16px;
//   color: white;
//   margin: -3em 0 0 0;
//   display: block;
//   text-align: center;

//   ${mediaQueries.tablet} {
//     font-size: 14px;
//   }
//   ${mediaQueries.mobile}{
//     font-size: 14px;
//     margin: -0.5em auto;
//     align-items: center;
    
//   }
// `

export default function SellingYourMidsole(props) {
    console.log("props.data for selling your midsole is", props.data);
    return(
        <Background>
            <DescriptionContainer>
                {props.data&&props.data.map(block=>{
                    if(block.type==="header"){
                        return(<Heading> {block.header} </Heading>);
                        
                    }
                    if(block.type==="subheader"){
                        return(<SubHeading> {block.content} </SubHeading>);
                    }
                    if(block.type==="paragraph"){
                        return(<Text> {block.content} </Text>);
                    }
                    if(block.type==="video"){
                        return(
                            <Video autoPlay muted loop controls>
                            <source src={block.video_link} type="video/mp4"/>
                            </Video>
                        );
                        
                    }
                })}
            </DescriptionContainer>
        </Background>
    );
}
